$( document ).ready(function() {

  var winWidth = $(window).width();

    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // $('.follow-links-title').on('click', function(e) {
  //   console.log('here');
  //   $('.follow-links').toggleClass('is-showing');
  // });

  $('.masthead--arrow').on('click', function(e) {

    e.preventDefault();

    var curEl         = $($(this).attr('href'));
    var nextOffset    = curEl.next().offset();

    if (winWidth > 1199 ) {
    var nextOffsetTop = nextOffset.top - 139;
  } else {
    var nextOffsetTop = nextOffset.top - 70;
  }

    $('html, body').animate({
      scrollTop: nextOffsetTop + 'px'
    }, 750);

  });

  // Add class to body on hamburger click
  $('.navbar-toggler').on('click', function(e) {
    e.preventDefault();
    $('body').toggleClass('menu-is-open');
  });

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode ? 'is-ie' : 'is-not-ie';

  $('body').addClass('is-loaded').addClass(isIE11);

  // Detect if banner has been scrolled past
  var navScrolled = function() {

    var $window    = $(window);
    var docViewTop = 90;
    var nav        = $('.banner');
    var elemTop    = $window.scrollTop();

    if ( elemTop > docViewTop ) {
      nav.addClass('scrolled');
    } else {
      nav.removeClass('scrolled');
    }

  };

  navScrolled();

  $( window ).scroll( function(e) {
    navScrolled();
  });

  if ( $('.blank').length > 0 ) {

    $('.blank').each( function(index, value) {
      $(this).find('a').attr('target','_blank').attr('rel','external noreferrer noopener');
    });

  }

  var curSection = getParameterByName('section');

  if ( curSection ) {

    var curSectionEl = $('#' + curSection);

    if ( curSectionEl.length > 0 ) {

      var scrollToAnchor = (function() {

        var bannerHeight = $('.banner').height();
        var anchorHeight = 60;
        var elemTop      = $(window).scrollTop();
        var curElOffset  = curSectionEl.offset();
        var totalOffset  = curElOffset.top - ( bannerHeight + anchorHeight);

        $('html, body').animate({
          scrollTop: totalOffset + 'px'
        }, 750);

      })();

    }

  }

});
